import { useRef, useState } from 'react'

import { IWidgetStyle } from '../../modules/theme/types'
import { ISessionUseCustomStyleState } from '../types'

const useCustomStyleState: ISessionUseCustomStyleState = () => {
  const [customStyle, setCustomStyle] = useState<IWidgetStyle>(null)
  const customStyleRef = useRef<IWidgetStyle>(null)
  customStyleRef.current = customStyle

  return { customStyleRef, setCustomStyle } as const
}

export default useCustomStyleState
